exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bookGrid{margin-top:20px}.bookGrid .bookContainer{margin-left:20px;margin-right:20px;margin-bottom:20px;display:inline-block;cursor:pointer;vertical-align:top}.bookGrid .bookContainer:hover{opacity:.7}.bookGrid .bookContainer .studentsDisplayContainer{margin:auto;margin-top:10px}.bookGrid .bookContainer .studentsDisplayContainer .moreStudentsContainer{position:relative;top:5px;left:5px}.bookGrid .bookContainer .studentsDisplayContainer .moreStudentsContainer .moreText{font-size:.8em}.bookGrid .emptySection .emptyBook{width:115px;border:1px dashed #ddd;height:170px;display:inline-block;margin-right:45px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/shelves/book_grid.scss
// module id = 1400
// module chunks = 0